import api from './api';

class UploadService {
  upload(file, onUploadProgress, studentId = null) {
    let formData = new FormData();

    formData.append("file", file);
    return api.post(studentId == null ? "/files/upload" : "/files/"+studentId+"/upload", formData, {
      headers: {
        "Content-Type": "multipart/form-data",
      },
      onUploadProgress,
    });
  }
  dossierUpload(file, onUploadProgress) {
    let formData = new FormData();

    formData.append("file", file);
    return api.post("/files/dossier/upload", formData, {
      headers: {
        "Content-Type": "multipart/form-data",
      },
      onUploadProgress,
    });
  }
  
  adminUpload(file, onUploadProgress) {
    let formData = new FormData();

    formData.append("file", file);
    return api.post("/files/static/upload", formData, {
      headers: {
        "Content-Type": "multipart/form-data",
      },
      onUploadProgress,
    });
  }
  getFile(filename) {
    return api.get('/files/'+filename, {responseType: 'blob'});
  }
  getThumbnail(filename) {
    return api.get('/files/'+filename + "?thumb=1", {responseType: 'blob'});
  }
  getStaticLink(filename) {
    return api.defaults.baseURL + 'filestatic/' + filename
  }
  getDossierFile(filename) {
    return api.get('/filedossier/'+filename, {responseType: 'blob'});
  }
  
  getLink(filename) {
    return api.defaults.baseURL + 'files/' + filename
  }
}

export default new UploadService();